"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _public = require("@/api/public/public");
var _scrollTo = require("../../../../public/js/scroll-to.js");
var _beforeMen = require("@/api/beforeMen/beforeMen");
var _index2 = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultYearOptions = ['2026', '2025'];
function buildYearOptions() {
  var yearList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var yearMap = new Map();
  defaultYearOptions.concat(yearList).forEach(function (item) {
    var option = typeof item === 'string' ? {
      name: item,
      id: ''
    } : item;
    var name = option && option.name ? String(option.name) : '';
    if (name && !yearMap.has(name)) {
      yearMap.set(name, option);
    }
  });
  return Array.from(yearMap.values()).sort(function (a, b) {
    return Number(b.name) - Number(a.name);
  });
}
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseItem: _courseItem.default,
    WinCourse: _winCourse.default
  },
  data: function data() {
    return {
      sum: [],
      jWinCourse: [{
        date: '人间正道- -认同政治制度,参与政治生活',
        name: '张老师'
      }, {
        date: '人间正道- -认同政治制度,参与政治生活',
        name: '张老师'
      }],
      tabList: [{
        name: '全部',
        id: ''
      }, {
        name: '国家规划教材数字课程',
        id: ''
      }, {
        name: '课程思政示范课',
        id: ''
      }, {
        name: '公共基础课',
        id: ''
      }, {
        name: '教学能力大赛获奖课程',
        id: ''
      }, {
        name: '班主任大赛获奖课程',
        id: ''
      }],
      curIndex: 0,
      menusList: [{
        tit: '层  次',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wCourseLevel)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '项  目',
        itemList: [{
          name: '全部',
          id: ''
        }, {
          name: '十三五国规教材配套',
          id: ''
        }, {
          name: '全国优秀教材配套',
          id: ''
        }],
        actheight: false,
        act: 0,
        isZhan: false
      }],
      menusList2: [{
        tit: '层  次',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wCourseLevel)),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      menusList4: [{
        tit: '层  次',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wCourseLevel)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '年  份',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(buildYearOptions(this.$store.getters.wYearListAll))),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      menusList5: [{
        tit: '年  份',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(buildYearOptions(this.$store.getters.wYearListAll))),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      total: 0,
      query: {
        courseLevel: "",
        courseName: "",
        courseProject: "",
        isPut: 1,
        pageNum: 1,
        pageSize: 20,
        provinceId: this.$store.getters.provinceId,
        year: ''
      },
      list: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      courseName: '',
      majorName: ''
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.courseName = e.courseName;
      this.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.majorName = e.majorName;
      this.getCourseList();
      this.getCourseList1();
      this.getCourseList2();
      this.getCourseList3();
      this.getCourseList4();
      this.getCourseList5();
    },
    lookDetails: function lookDetails(e) {
      window.open(e.courseLink);
    },
    toTabs: function toTabs(i, j) {
      if (j == 0) {
        this.getCourseList1();
        this.getCourseList2();
        this.getCourseList3();
        this.getCourseList4();
        this.getCourseList5();
        this.counts();
      } else if (j == 1) {
        this.query.courseType = '3';
      } else if (j == 2) {
        this.query.courseType = '2';
      } else if (j == 3) {
        this.query.courseType = '6';
      } else if (j == 4) {
        this.query.courseType = '5';
      } else if (j == 5) {
        this.query.courseType = '4';
      }
      this.curIndex = j;
      this.query.videoOpenClassType = i.id;
      this.query.courseLevel = '';
      this.query.courseProject = '';
      this.query.year = '';
      this.query.pageNum = 1;
      this.getCourseList();
      (0, _scrollTo.scrollTo)(500, 800);
    },
    counts: function () {
      var _counts = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, arr, i;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _index2.getCourseTypeCount)({
                id: this.$store.getters.provinceId
              });
            case 1:
              res = _context.sent;
              arr = [];
              for (i in res.data) {
                arr.push(res.data[i]);
              }
              this.sum = arr;
              console.log(this.sum[1]);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function counts() {
        return _counts.apply(this, arguments);
      }
      return counts;
    }(),
    tabs: function tabs(i, j) {
      console.log(i, j, '88888');
      this.query = {
        courseLevel: "",
        courseName: "",
        courseProject: "",
        isPut: 1,
        pageNum: 1,
        pageSize: 20,
        provinceId: this.$store.getters.provinceId,
        year: ''
      };
      if (j == 0) {
        this.getCourseList1();
        this.getCourseList2();
        this.getCourseList3();
        this.getCourseList4();
        this.getCourseList5();
      } else if (j == 1) {
        this.query.courseType = '3';
      } else if (j == 2) {
        this.query.courseType = '2';
      } else if (j == 3) {
        this.query.courseType = '6';
      } else if (j == 4) {
        this.query.courseType = '5';
      } else if (j == 5) {
        this.query.courseType = '4';
      }
      this.curIndex = j;
      this.query.videoOpenClassType = i.id;
      this.query.courseLevel = '';
      this.query.courseProject = '';
      this.query.year = '';
      this.query.pageNum = 1;
      for (var _i in this.menusList) {
        this.menusList[_i].act = 0;
      }
      for (var _i2 in this.menusList2) {
        this.menusList2[_i2].act = 0;
      }
      for (var _i3 in this.menusList4) {
        this.menusList4[_i3].act = 0;
      }
      for (var _i4 in this.menusList5) {
        this.menusList5[_i4].act = 0;
      }
      this.getCourseList();
    },
    chooseList: function chooseList(e) {
      console.log(e, '56789');
      if (e[0] == '层  次') {
        if (e[1].name == '全部') {
          this.query.schoolLevel = '';
        } else {
          this.query.schoolLevel = e[1].name;
        }
      } else if (e[0] == '项  目') {
        if (e[1].name == '全部') {
          this.query.project = '';
        } else {
          this.query.project = e[1].name;
        }
      } else if (e[0] == '年  份') {
        if (e[1].name == '全部') {
          this.query.year = '';
        } else {
          this.query.year = e[1].name;
        }
      }
      this.query.pageNum = 1;
      this.getCourseList();
      // console.log('zizujian',e)
    },
    getTypeList: function getTypeList() {
      /*        videoOpenClassType({
                provinceId: this.$store.getters.provinceId
              }).then(res => {
                this.tabList = [{
                  name: '全部',
                  id: ''
                }, ...res.data]
                });*/
      this.getCourseList1();
      this.getCourseList2();
      this.getCourseList3();
      this.getCourseList4();
      this.getCourseList5();
    },
    getXiangmuList: function getXiangmuList() {
      var _this = this;
      (0, _beforeMen.courseProject)({
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        _this.menusList[1].itemList = [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(res.data));
      });
    },
    // 获取课程
    getCourseList: function getCourseList() {
      var _this2 = this;
      (0, _index2.getReceptionList)(this.query).then(function (res) {
        _this2.list = res.rows;
        _this2.total = res.total;
      });
    },
    //获取综合页数据
    getCourseList1: function getCourseList1() {
      var _this3 = this;
      (0, _index2.getReceptionList)({
        courseName: this.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 4,
        projectLevel: "",
        // provinceId: this.$store.getters.provinceId,
        courseType: '3',
        schoolId: '',
        majorName: this.majorName
      }).then(function (res) {
        _this3.list1 = res.rows; //国家规划教材数字课程
      });
    },
    getCourseList2: function getCourseList2() {
      var _this4 = this;
      (0, _index2.getReceptionList)({
        courseName: this.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 4,
        projectLevel: "",
        // provinceId: this.$store.getters.provinceId,
        courseType: '2',
        schoolId: '',
        majorName: this.majorName
      }).then(function (res) {
        _this4.list2 = res.rows; //课程思政示范项目
        console.log(res, 'this.list2');
      });
    },
    getCourseList3: function getCourseList3() {
      var _this5 = this;
      (0, _index2.getReceptionList)({
        courseName: this.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 4,
        projectLevel: "",
        // provinceId: this.$store.getters.provinceId,
        courseType: '6',
        schoolId: '',
        majorName: this.majorName
      }).then(function (res) {
        _this5.list3 = res.rows; //公共基础课
      });
    },
    getCourseList4: function getCourseList4() {
      var _this6 = this;
      (0, _index2.getReceptionList)({
        courseName: this.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 4,
        projectLevel: "",
        // provinceId: this.$store.getters.provinceId,
        courseType: '5',
        schoolId: '',
        majorName: this.majorName
      }).then(function (res) {
        _this6.list4 = res.rows; //教学能力大赛获奖课程
      });
    },
    getCourseList5: function getCourseList5() {
      var _this7 = this;
      (0, _index2.getReceptionList)({
        courseName: this.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 4,
        projectLevel: "",
        // provinceId: this.$store.getters.provinceId,
        courseType: '4',
        schoolId: '',
        majorName: this.majorName
      }).then(function (res) {
        _this7.list5 = res.rows; //班主任大赛获奖课程
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getCourseList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getCourseList();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return this.getTypeList();
          case 1:
            _context2.next = 2;
            return this.getCourseList();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};